import { FormField, Input } from '~/core/shared/components';
import { FieldProps } from '../DocumentField.component';

export const InputField = (props: FieldProps<Resources.FormInputField>) => (
  <FormField component={Input} {...props} />
);
